import { render, staticRenderFns } from "./CreateMessageListModal.vue?vue&type=template&id=385d9250&scoped=true"
import script from "./CreateMessageListModal.vue?vue&type=script&lang=js"
export * from "./CreateMessageListModal.vue?vue&type=script&lang=js"
import style0 from "./CreateMessageListModal.vue?vue&type=style&index=0&id=385d9250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d9250",
  null
  
)

export default component.exports